<template>
  <CautionTemplate v-show="hasServerError" class="cautionArea">
    <p v-if="errorType === REGISTER_ERROR_TYPES.TOKEN_CHECK_ERROR" class="cautionText">
      不正な操作が発生しました。<br />
      <a class="cautionLink" :href="selfLocationPath">こちら</a>からやり直してください。
    </p>
    <p v-if="errorType === REGISTER_ERROR_TYPES.SESSION_EXPIRE" class="cautionText">
      しばらくの間操作がなかったため、セッション切れとなりました。<br />
      <a class="cautionLink" :href="selfLocationPath">こちら</a>からやり直してください。
    </p>
    <p v-if="errorType === REGISTER_ERROR_TYPES.DUPLICATE_REGISTER" class="cautionText">
      <!-- 『PCは改行不要』指定のため、統一しないこと -->
      <template v-if="notNeedToLoginButton">
        すでに登録されているメールアドレスです。<br v-show="isSp" />別のメールアドレスを入力してください。
      </template>
      <template v-else>
        すでに登録済みのメールアドレスです。<br v-show="isSp" />
        <a class="cautionLink" :href="`/${urlPrefix}/quipMember/auth/signIn/`">こちら</a>からログインしてください。
      </template>
    </p>
    <p v-if="errorType === REGISTER_ERROR_TYPES.SYSTEM_ERROR" class="cautionText">
      予期せぬエラーが発生しました。<a class="cautionLink" :href="`/${urlPrefix}/quipMember/register/infoInput/`"
        >こちら</a
      >からやり直してください。
    </p>
    <p v-for="message in serverErrorList" :key="message" class="cautionText">
      {{ message }}
    </p>
  </CautionTemplate>
</template>

<script>
import CautionTemplate from './Caution/CautionTemplate.vue';
import { REGISTER_ERROR_TYPES } from './_registerResponseCheck';

export default {
  components: {
    CautionTemplate,
  },
  props: {
    isSpFlg: {
      type: Boolean,
      required: false,
      default: undefined,
    },
    errorType: {
      type: String,
      required: false,
      default: undefined,
      validator(value) {
        return Object.values(REGISTER_ERROR_TYPES).indexOf(value) !== -1;
      },
    },
    serverErrorList: {
      type: Array,
      required: true,
      default: () => [],
    },
    notNeedToLoginButton: {
      type: Boolean,
      required: false,
      default: undefined,
    },
  },
  computed: {
    isSp() {
      if (typeof this.isSpFlg === 'boolean') return this.isSpFlg;
      return this.$isSp;
    },
    urlPrefix() {
      return this.$isSp ? 'smp2' : 'net2';
    },
    REGISTER_ERROR_TYPES() {
      return REGISTER_ERROR_TYPES;
    },
    hasServerError() {
      return this.serverErrorList.length !== 0 || this.errorType !== undefined;
    },
    selfLocationPath() {
      return window.location.href;
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'css/contents/common/global';

.cautionArea {
  .cautionText {
    margin-bottom: 8px;
    line-height: $text-line-height-default;

    .cautionLink {
      color: #e62525;
      text-decoration: underline;

      &:hover {
        text-decoration: none;
      }

      &:active {
        text-decoration: none;
      }
    }

    &:last-of-type {
      margin-bottom: 0;
    }
  }
}
</style>
